import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import {
  flexBoxCenter,
  justifyContentFlexEnd,
  justifyContentFlexStart,
  justifyContentSpaceBetween,
  layerA,
  layerBDark,
  scrollbarY,
} from '../../styles/commonStyles';
import { selectForceCommandAndAdminSelect } from '../../store/slices/settings/force&CommandAndAdminSelectSlice';
import SelectIndividualOptions from '../../telemetry/theSelections/SelectIndividualOptions';
import ClearApplyButton from './selectArts/ClearApplyButton';
import { useMediaQuery } from 'react-responsive';
import { useSelectBoxArrowsState } from '../../../hooks/useSelectBoxArrowsState';
import { mainSelectIndicatorHandler } from '../../../helpers/setting/select_box_indicator';
import { buttonsHandler } from '../../../helpers/setting/select_box_buttons_dispatchers';
import { useGetSpecificLocationList } from '../../../hooks';

const SelectFCSwitchMachineOptions = ({
  handleClose,
  data,
  sysIndex,
  swtName,
}) => {
  const isMobile = useMediaQuery({ query: '(max-width:600px)' });

  const locations = Object.keys(data);
  const buttons = ['clear', 'select'];

  const FCAndAdminSelectState = useSelector(selectForceCommandAndAdminSelect);
  const swt = sysIndex === 0 ? 'ess' : sysIndex === 1 ? 'tgs' : 'tes';

  const {
    isAllSelected,
    isLocationSelected,
    isSpecificLocationSelected,
    isMachineSelected,
    selectedLocations,
    selectedSpecificLocations,
    selectedMachines,
  } =
    sysIndex === 0
      ? FCAndAdminSelectState.ess
      : sysIndex === 1
        ? FCAndAdminSelectState.tgs
        : sysIndex === 2
          ? FCAndAdminSelectState.tes
          : '';

  const [isSelected, setIsSelected] = useState(false);

  const { trackArrowState, trackSpecLocationArrowState, specificLocations } =
    useSelectBoxArrowsState(data);

  const [isArrowDown, setIsArrowDown] = useState(trackArrowState);
  const [isSpecLocationArrowDown, setIsSpecLocationArrowDown] = useState(
    trackSpecLocationArrowState,
  );
  const dispatch = useDispatch();

  const specificLocationsNameList = useGetSpecificLocationList(data);

  const handleOnClick = (...props) => {
    const propsObj = {
      button: props[1],
      isAllSelected,
      isLocationSelected,
      isSpecificLocationSelected,
      isMachineSelected,
      selectedLocations,
      selectedSpecificLocations,
      selectedMachines,
      swtName,
      dispatch,
      data,
      locations,
      handleClose,
      isSelected,
      program: 'forceAndCommand',
    };

    buttonsHandler(propsObj);
  };

  const handleSelect = (option, machine, extraOption, machineIndex) => {
    setIsSelected(true);
    const propObj = {
      dispatch,
      data,
      locations,
      swtName,
      specificLocations,
      isLocationSelected,
      isSpecificLocationSelected,
      isMachineSelected,
      isAllSelected,
      selectedLocations,
      selectedSpecificLocations,
      selectedMachines,
      option,
      machine,
      extraOption,
      machineIndex,
    };
    mainSelectIndicatorHandler(propObj);
  };

  return (
    <>
      {isMobile
        ? swt && (
            <Wrapper>
              <SectionOptions isMobile={true}>
                <SelectIndividualOptions
                  option='all'
                  handleSelect={handleSelect}
                  isSelected={isAllSelected}
                  isFirst={true}
                />

                {locations.map((location, index) => (
                  <SelectIndividualOptions
                    key={index}
                    index={index}
                    option={location}
                    data={data[location]}
                    handleSelect={handleSelect}
                    isSelected={isLocationSelected[index]}
                    isMachineSelected={
                      isMachineSelected[index] && isMachineSelected[index]
                    }
                    isSpecificLocationSelected={
                      isSpecificLocationSelected &&
                      isSpecificLocationSelected[index]
                    }
                    isSpecLocationArrowDown={isSpecLocationArrowDown}
                    setIsSpecLocationArrowDown={setIsSpecLocationArrowDown}
                    isArrowDown={isArrowDown}
                    setIsArrowDown={setIsArrowDown}
                    allSpecificLocationsName={specificLocationsNameList}
                  />
                ))}
              </SectionOptions>
              <SectionButtons isMobile={true}>
                {buttons.map((button, index) => (
                  <div key={index}>
                    <ClearApplyButton
                      name={button}
                      handleClick={handleOnClick}
                      index={index}
                      isMobile={true}
                    />
                  </div>
                ))}
              </SectionButtons>
            </Wrapper>
          )
        : swt && (
            <Wrapper>
              <ScrollBarWrapper>
                <SectionOptions>
                  <SelectIndividualOptions
                    option='all'
                    handleSelect={handleSelect}
                    isSelected={isAllSelected}
                  />

                  {locations.map((location, index) => (
                    <SelectIndividualOptions
                      key={index}
                      index={index}
                      option={location}
                      data={data[location]}
                      handleSelect={handleSelect}
                      isSelected={isLocationSelected[index]}
                      isMachineSelected={
                        isMachineSelected[index] && isMachineSelected[index]
                      }
                      isSpecificLocationSelected={isSpecificLocationSelected}
                      isSpecLocationArrowDown={isSpecLocationArrowDown}
                      setIsSpecLocationArrowDown={setIsSpecLocationArrowDown}
                      isArrowDown={isArrowDown}
                      setIsArrowDown={setIsArrowDown}
                      allSpecificLocationsName={specificLocationsNameList}
                    />
                  ))}
                </SectionOptions>
              </ScrollBarWrapper>
              <SectionButtons>
                {buttons.map((button, index) => (
                  <div key={index}>
                    <ClearApplyButton
                      name={button}
                      handleClick={handleOnClick}
                      index={index}
                    />
                  </div>
                ))}
              </SectionButtons>
            </Wrapper>
          )}
    </>
  );
};

export default SelectFCSwitchMachineOptions;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  ${justifyContentSpaceBetween}
  flex-direction: column;
`;

const ScrollBarWrapper = styled.div`
  width: 252px;
  min-height: 120px;
  max-height: 186px;
  padding: 4px;
  margin-bottom: 4px;
  border-radius: 14px 8px 8px 14px;
  ${layerA}
  ${justifyContentFlexStart}
`;

const SectionOptions = styled.div`
  ${scrollbarY}
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 273px;
          max-height: 184px;
          margin-top: 4px;
          ${layerA}
          border-radius: 18px;
          ::-webkit-scrollbar {
            display: none;
          }
          ${justifyContentFlexStart}
        `
      : css`
          min-height: 112px;
          max-height: 178px;
          width: 100%;
          display: flex;
          justify-items: flex-start;
          align-items: flex-start;
        `}

  flex-direction: column;
`;

const SectionButtons = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 98%;
          gap: 12px;
          margin-top: 10px;
          margin-bottom: 8px;
          ${flexBoxCenter}
        `
      : css`
          width: 100%;
          margin-bottom: 2px;
          ${justifyContentFlexEnd};
          gap: 8px;
        `}

  height: auto;
`;
